import axiosIns from '../../../xaxios';
import { obtenerUrlAPIPagos } from '../utils/funciones';

export default {
  async findOne(id, opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIPagos(`solicitudes-pagos-reportes/${id}`), opciones);
  },
  async findAllPorProgramaUniversidadId(programaUniversidadId, opciones = { params: {} }) {
    return await axiosIns.get(
      obtenerUrlAPIPagos(`solicitudes-pagos-reportes/programas-universidades/${programaUniversidadId}`),
      opciones,
    );
  },
};
